/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Location1Inputs */

const zh_accountsettings_location1 = /** @type {(inputs: Accountsettings_Location1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置`)
};

const en_accountsettings_location1 = /** @type {(inputs: Accountsettings_Location1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

const es_accountsettings_location1 = /** @type {(inputs: Accountsettings_Location1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Accountsettings_Location1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_location1 = /** @type {((inputs?: Accountsettings_Location1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Location1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_location1(inputs)
	if (locale === "en") return en_accountsettings_location1(inputs)
	return es_accountsettings_location1(inputs)
});
export { accountsettings_location1 as "accountSettings_location" }